<div class="contenedor row">
    <mat-card class="cardWithShadow">
        <mat-card-content class="p-24">

            <div class="row">
                <div class="col-md-5">
                    <mat-card-title style="font-weight: bold; color: #003c8a;">Mi Información</mat-card-title>
                </div>
            </div>

            <hr/>
    
            <div *ngIf="myInfo; else loading" style="margin-top: 15px;">
                <p>
                    <b>Nombre: </b>
                    {{ myInfo.name }} {{ myInfo.lastName }}
                </p>
                <p>
                    <b>Rut: </b>
                    {{ myInfo.rut }}
                </p>
                <p>
                    <b>Email: </b>
                    {{ myInfo.email }}
                    <fa-icon
                        [icon]="icons.faPen"
                        style="cursor: pointer; font-size: 16px; margin-left: 1rem"
                        (click)="openUpdateInfoClientComponent('email')">
                    </fa-icon>  
                </p>
                <p>
                    <b>Telefono: </b>
                    {{ myInfo.phone }}
                    <fa-icon
                        [icon]="icons.faPen"
                        style="cursor: pointer; font-size: 16px; margin-left: 1rem"
                        (click)="openUpdateInfoClientComponent('telefono')">
                    </fa-icon>
                </p>
            </div>

            <ng-template #loading>
                <div class="spinner">
                    <mat-spinner [diameter]="60"></mat-spinner>
                </div>
            </ng-template>
    
        </mat-card-content>
    </mat-card>

    <mat-card class="cardWithShadow">
        <mat-card-content class="p-24">
            
            <div class="row">
                <div class="col-md-5">
                    <mat-card-title style="font-weight: bold; color: #003c8a;">Mi Cuenta</mat-card-title>
                </div>
            </div>

            <hr/>
    
            <div *ngIf="myInfo; else loading" style="margin-top: 15px;">
                <p style="display: flex; align-items: center; justify-content: space-between;">
                    <b>Contraseña: ********</b>
                    <!--<span style="cursor: pointer; color: blue;" (click)="openModalChanguePassClient()">Cambiar</span>-->
                    <button
                        mat-stroked-button
                        (click)="openModalChanguePassClient()"
                        color="primary"
                        type="submit"
                        class="w-50"
                        style=""
                    >
                        Cambiar
                    </button>
                    <!--<mat-chip-set>
                        <mat-chip class="chip-with-icon">
                          <span (click)="openModalChanguePassClient() style="color: #003c8a;">Cambiar</span>
                        </mat-chip>
                    </mat-chip-set> -->
                </p>
            </div>

        </mat-card-content>
    </mat-card>
</div>